import React from 'react'
import "./SubStyle.css"

const CQC_Mock = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">Mock Inspections</h1>
      <p className="SubServices-pera">Our comprehensive Mock Inspection service mirrors the CQC inspection process, providing a realistic assessment of your service. We identify strengths, highlight areas requiring improvement, and deliver practical recommendations to help you achieve better inspection outcomes and maintain compliance.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default CQC_Mock
